<template>
  <div id="modalErrorLog" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-md"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.错误日志") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <p v-for="(l, i) in logs" :key="i" class="mg-b-10">{{ l }}</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("product.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["log"],
  data() {
    return {
      logs: [],
    };
  },
  watch: {
    log: function () {
      this.logs = JSON.parse(this.log);
    },
  },
};
</script>